import React, {FC, ReactElement} from 'react';
import styles from './index.module.scss';
import {useTranslation} from "react-i18next";

interface Props {
    onClose: () => void
}

const FailModal: FC<Props> = ({onClose}): ReactElement => {
    const {t} = useTranslation();
    return (
        <div className={styles.modal}>
            <div className={styles.overlayCss} onClick={() => onClose()}></div>
            <div className={styles.contentCss}>
                <div className={styles.topContent}>
                    <img src={require('img/icon_fail.png').default} alt=''/>

                </div>
                <p>{t('home.transactionFailed')}</p>
                <div className={styles.line}></div>
                <div className={styles.confirm} onClick={() => onClose()}>{t('home.Acknowledged')}</div>
            </div>
        </div>
    )
}

export default FailModal
